import { useRef } from "react";
import './ContactCss/Agree.css';

function Agree(props){

    const modalRef = useRef();
    const modalOutClick = (e) => {
        if(modalRef.current === e.target){
            props.setVal('')
        }
    }

    return(
        <div className="valid2" ref={modalRef} onClick={(e)=>{modalOutClick(e)}}>
            <div className="valid-modal2">
                <div className="valid-modal-all2">
                    <p className="valid-modal-font2">
                        ‘㈜기보’ 는 (이하 ‘기보’는) 고객님의 개인정보를 중요시하며, “정보통신망 이용촉진 및 정보보호”에 관한 법률을 준수하고 있습니다.
                        <br></br><br></br>회사는 개인정보취급방침을 통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 
                        <br></br>개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.

                        <br></br><br></br>기보는 개인정보취급방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.

                        <br></br><br></br>ο 본 방침은 : 2024 년 06 월 10 일 부터 시행됩니다.
                    
                        <br></br><br></br>■ 수집하는 개인정보 항목
                    
                        <br></br><br></br>기보는 고객문의 등을 위해 아래와 같은 개인정보를 수집하고 있습니다.

                        <br></br><br></br>ο 수집항목 : 이름, 업체명, 연락처, 이메일

                        <br></br><br></br>ο 개인정보 수집방법 : 홈페이지(문의하기) 를 통한 문의

                        <br></br><br></br>■ 개인정보의 수집 및 이용목적

                        <br></br><br></br>기보는 수집한 개인정보를 다음의 목적을 위해 활용합니다.

                        <br></br><br></br>ο 문의내용 확인 및 안내를 위한 연락

                        <br></br><br></br>■ 개인정보의 수집 및 보유기간

                        <br></br><br></br>고객의 개인정보는 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기하며, 보유기간은 최대 3년을 넘기지 않는 것을 원칙으로 합니다.

                        <br></br><br></br>■ 개인정보의 자동 수집 장치의 설치/운영 및 거부에 관한 사항

                        <br></br><br></br>당 홈페이지는 이용자에게 개별적인 맞춤서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용하지 않습니다.

                        <br></br><br></br>■ 개인정보에 관한 민원서비스

                        <br></br><br></br>기보는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 개인정보관리책임자를 지정하고 있습니다.

                        <br></br>개인정보관리책임자 : 기보
                        <br></br>전화번호 : 031-733-7568
                        <br></br>이메일 : ceo@givo.co.kr
                    </p>
                    <div className="valid-modal-button2">
                        <button className="valid-modal-check2" onClick={()=>{props.setVal('')}}>
                            닫기
                        </button>
                    </div>
                </div>
            </div>            
        </div>     
    )
}

export default Agree;
